"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialMVRMeasurementInputs = exports.initialMeasurementInputs = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
exports.initialMeasurementInputs = [
    {
        name: 'working',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'scaffolding_bridges_and_ladders',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'machinery_and_equipments',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'fallprotections',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'electrics_and_lighting',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'general_order_and_garbage_collecting',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'dustines',
        value: {
            correct: 0,
            wrong: 0
        }
    }
];
exports.initialMVRMeasurementInputs = [
    {
        name: 'working_and_machine_use',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'equipment',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'protection_and_safety_zones',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'driveways_and_walkways',
        value: {
            correct: 0,
            wrong: 0
        }
    },
    {
        name: 'order_and_storage',
        value: {
            correct: 0,
            wrong: 0
        }
    }
];
var enhance = (0, recompose_1.compose)(react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({}), recompose_1.pure);
var handleValueUpdate = function (measurements, measurementIdx, correct, addition, setMeasurementsInput) {
    if (!measurements) {
        return;
    }
    var measurement = measurements[measurementIdx];
    var newValue;
    if (measurement.value) {
        if (correct) {
            if (addition) {
                newValue = __assign(__assign({}, measurement.value), { correct: measurement.value.correct + 1 });
            }
            else {
                var newFalse = measurement.value.correct - 1 < 0 ? 0 : measurement.value.correct - 1;
                newValue = __assign(__assign({}, measurement.value), { correct: newFalse });
            }
        }
        else {
            if (addition) {
                newValue = __assign(__assign({}, measurement.value), { wrong: measurement.value.wrong + 1 });
            }
            else {
                var newFalse = measurement.value.wrong - 1 < 0 ? 0 : measurement.value.wrong - 1;
                newValue = __assign(__assign({}, measurement.value), { wrong: newFalse });
            }
        }
        var newMeasurement = __assign(__assign({}, measurement), { value: newValue });
        var newMeasurements = __spreadArray(__spreadArray(__spreadArray([], measurements.slice(0, measurementIdx), true), [
            newMeasurement
        ], false), measurements.slice(measurementIdx + 1), true);
        setMeasurementsInput(newMeasurements);
    }
};
exports.default = enhance(function (props) {
    var correctSum = 0;
    var wrongSum = 0;
    if (props.measurementsInput) {
        props.measurementsInput.map(function (measurement) {
            correctSum += measurement.value.correct;
            wrongSum += measurement.value.wrong;
        });
    }
    return (React.createElement("div", { className: "measurements-content" },
        React.createElement("div", null,
            React.createElement("div", { className: "right-wrong-title" },
                React.createElement("div", { className: "right" }, (0, translation_1.getLocalization)('trmvrEntry/right')),
                React.createElement("div", { className: "wrong" },
                    " ",
                    (0, translation_1.getLocalization)('trmvrEntry/wrong'))),
            props.measurementsInput !== undefined &&
                props.measurementsInput.map(function (measurement, idx) {
                    var idxVal;
                    if (idx === 5) {
                        idxVal = '6a';
                    }
                    else if (idx === 6) {
                        idxVal = '6b';
                    }
                    else {
                        idxVal = idx + 1;
                    }
                    return (React.createElement("div", { className: "measurements-input-row", key: measurement.name },
                        React.createElement("div", { className: "measurement" },
                            idxVal,
                            ".",
                            ' ',
                            (0, translation_1.getLocalization)("trmvrEntry/measurements/".concat(measurement.name))),
                        React.createElement("div", { className: "measurement-buttons-and-values" },
                            React.createElement(sok_ui_1.Button, { className: "button-minus-green", icon: React.createElement(sok_ui_1.Icon, { className: "fa fa-minus" }), color: "white", disabled: props.disabled, onClick: function () {
                                    return handleValueUpdate(props.measurementsInput, idx, true, false, props.setMeasurementsInput);
                                } }),
                            React.createElement("div", { className: "measurements-input-row-value" }, measurement.value && measurement.value.correct),
                            React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-plus" }), color: "green", disabled: props.disabled, onClick: function () {
                                    return handleValueUpdate(props.measurementsInput, idx, true, true, props.setMeasurementsInput);
                                } }),
                            React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-plus" }), color: "red", disabled: props.disabled, onClick: function () {
                                    return handleValueUpdate(props.measurementsInput, idx, false, true, props.setMeasurementsInput);
                                } }),
                            React.createElement("div", { className: "measurements-input-row-value" }, measurement &&
                                measurement.value &&
                                measurement.value.wrong),
                            React.createElement(sok_ui_1.Button, { className: "button-minus-red", icon: React.createElement(sok_ui_1.Icon, { className: "fa fa-minus" }), color: "white", disabled: props.disabled, onClick: function () {
                                    return handleValueUpdate(props.measurementsInput, idx, false, false, props.setMeasurementsInput);
                                } }),
                            React.createElement("div", { className: "measurements-input-percent" },
                                measurement.value && measurement.value.correct > 0
                                    ? ((measurement.value.correct /
                                        (measurement.value.correct +
                                            measurement.value.wrong)) *
                                        100).toFixed(2)
                                    : 0,
                                "%"))));
                })),
        React.createElement("div", { className: "tr-level" },
            React.createElement("div", { className: "tr-level-title" }, props.measurementType === 'TRMETER'
                ? (0, translation_1.getLocalization)('trmvrEntry/measurements/trlevel')
                : (0, translation_1.getLocalization)('trmvrEntry/measurements/mvrlevel')),
            React.createElement("div", { className: "tr-level-values" },
                React.createElement("div", { className: "tr-level-value correct" }, correctSum),
                React.createElement("div", { className: "tr-level-value wrong" }, wrongSum),
                React.createElement("div", { className: "tr-level-percent" },
                    correctSum > 0
                        ? ((correctSum / (correctSum + wrongSum)) * 100).toFixed(2)
                        : 0,
                    "%")))));
});
